import script from "./ProjectBrand.vue?vue&type=script&lang=ts&setup=true&name=StandardList"
export * from "./ProjectBrand.vue?vue&type=script&lang=ts&setup=true&name=StandardList"

import "./ProjectBrand.vue?vue&type=style&index=0&id=2114800c&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2114800c"]])

export default __exports__